const validator = {
  getMessage () {
    return 'É necessário ter pelo menos 18 anos de idade'
  },
  validate (value) {
    if (!value) {
      return false
    }
    
    // Remove máscara se houver (remove tudo que não é dígito)
    const dateStr = value.replace(/\D/g, '')
    
    // Verifica se tem 8 dígitos (ddMMyyyy)
    if (dateStr.length !== 8) {
      return false
    }
    
    // Extrai dia, mês e ano
    const day = parseInt(dateStr.substring(0, 2), 10)
    const month = parseInt(dateStr.substring(2, 4), 10) - 1 // Mês começa em 0 no JS
    const year = parseInt(dateStr.substring(4, 8), 10)
    
    // Validação básica dos valores
    if (isNaN(day) || isNaN(month) || isNaN(year)) {
      return false
    }
    
    // Cria objeto Date
    const birthDate = new Date(year, month, day)
    
    // Verifica se a data é válida (evita datas inválidas como 31/02)
    if (birthDate.getDate() !== day || birthDate.getMonth() !== month || birthDate.getFullYear() !== year) {
      return false
    }
    
    // Verifica se a data não é no futuro
    const today = new Date()
    today.setHours(0, 0, 0, 0)
    if (birthDate > today) {
      return false
    }
    
    // Calcula a idade
    let age = today.getFullYear() - birthDate.getFullYear()
    const monthDiff = today.getMonth() - birthDate.getMonth()
    
    // Ajusta a idade se ainda não fez aniversário este ano
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
      age--
    }
    
    // Verifica se tem pelo menos 18 anos
    return age >= 18
  }
}

export default validator

